export default "__VITE_PUBLIC_ASSET__086ccf81__"